import * as angular from "angular";
import {BringozArray} from "../persistence-layer/bringoz-array";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";



angular
  .module('bringoz.admin.agreements')
  .factory('$agreements', AgreementsArrayFactory);

export type $agreementsFactory = () => BringozArray<any>;

/* @ngInject */
function AgreementsArrayFactory($bringozFactory: $bringozFactory,
                                agreementAPI: BringozApi,
                                Agreements_DS: DataStoreConfig) {
  function $agreements() {
    return $bringozFactory<any>(null, agreementAPI, Agreements_DS);
  }

  return $agreements;
}
